import React, { useEffect } from "react";
import Footer from "./layout/footer/footer";
import Navbar from "./navbar/navbar";
import Banner from "./navbar/banner";
import "../styles/typography.scss";
import "./layout.module.scss";
import { storeVisitorId, storeFirstVisitInfo, storeCurrentVisitInfo } from "@utils/visitTracking";
import { useLocation } from "@reach/router";

export default function Layout({ noNavFooter, className, children, navColorVariant = "peach" }) {
  const location = useLocation();

  useEffect(() => {
    // we're storing details of the visitor, first visit, and current visit like UTM, URL, etc
    // so that we can later pass it along with lead info details
    storeVisitorId();
    storeFirstVisitInfo(location);
    storeCurrentVisitInfo(location);
  }, []);

  const noTransparentNavBar = React.useMemo(() => {
    switch (location.pathname) {
      case "/why-mangomint/":
      case "/pricing/":
      case "/beautiful/":
      case "/beautiful/apply/":
        return true;
      default:
        return false;
    }
  }, [location.pathname]);

  const footerIncludeGradient = React.useMemo(() => {
    if (
      location.pathname.includes("/payments/") ||
      location.pathname.includes("/go/") ||
      location.pathname.includes("/features/") ||
      location.pathname.includes("/solutions/") ||
      location.pathname.includes("/tour/") ||
      location.pathname.includes("/videos/") ||
      location.pathname.includes("/about-us/") ||
      location.pathname.includes("/integrations/")
    ) {
      return true;
    }
    switch (location.pathname) {
      case "/":
      case "/pricing/":
      case "/beautiful/":
      case "/why-mangomint/":
        return true;
      case "/solutions/":
        return false;
      default:
        return false;
    }
  }, [location.pathname]);

  return (
    <>
      {!noNavFooter && (
        <>
          <Banner />
          <Navbar noTransparent={noTransparentNavBar} navColorVariant={navColorVariant} />
        </>
      )}
      <main className={className}>{children}</main>
      {!noNavFooter && <Footer includeGradient={footerIncludeGradient} />}
    </>
  );
}
